










import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LanguageDto, UserDto } from "@/server/app.dtos";
import { GridColumn, GridColumnTypes } from "@/models/grids/column";

@Component
export default class UserDetailDocumentsPage extends Vue {
  @Prop() user!: UserDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;

  columns: GridColumn[] = [
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Ficheiro",
      value: "filename",
      type: GridColumnTypes.FileAny,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Público",
      value: "isPublic",
      type: GridColumnTypes.Boolean,
      editable: true,
      editableClass: "col-12"
    }
  ];
  primary: string = "idEntityFile";
}
